<template>
  <div
    ref="dropdownContainer"
    class="dropdown-container flex"
    @click="toggleDropdown"
  >
    <div class="dropdown-selected">
      {{
        selectedOption
          ? selectedOption.name.length > 15
            ? selectedOption.name.substring(0, 15) + '...'
            : selectedOption.name
          : placeholder
      }}
    </div>
    <div class="calendar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.5"
        height="15.5"
        viewBox="0 0 15.5 7.5"
        :class="{'rotate-180': isDropdownOpen}"
      >
        <path
          id="_5a4c1064a3ce6606a5e3693ac39c5e09"
          data-name="5a4c1064a3ce6606a5e3693ac39c5e09"
          d="M11.512,8.431a.75.75,0,0,1,.976,0l7,6a.75.75,0,1,1-.976,1.139L12,9.988,5.488,15.569a.75.75,0,1,1-.976-1.139Z"
          transform="translate(19.75 15.75) rotate(180)"
          fill="#bcbcbc"
          fill-rule="evenodd"
        />
      </svg>
    </div>
    <div v-if="isOpen" class="dropdown-options bg-white dark:bg-slate-900">
      <div
        v-for="state in states"
        :key="state.id"
        class="dropdown-option"
        :class="{
          'selected-option': selectedOption && selectedOption.id === state.id,
        }"
        @click="selectOption(state)"
        :title="state.name.length > 15 ? state.name : ''"
      >
        <!-- {{ state.name }} -->
        {{
          state.name.length > 15
            ? state.name.substring(0, 15) + '...'
            : state.name
        }}
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  props: {
    states: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select an option',
    },
    addMoreLabel: {
      type: String,
      default: 'Add More',
    },
    open: {
      type: Boolean,
      required: false,
    },
  },
  watch:{
    open(newVal){
      this.isOpen=newVal;
      this.isDropdownOpen = newVal;
    }
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      isDropdownOpen: false,
    };
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation(); // Prevents toggleDropdown from closing immediately on open
      // this.isOpen = !this.isOpen;
      this.isDropdownOpen = true;
      this.$emit("toggle");
    },
    selectOption(option) {
      this.selectedOption = option;
      this.isOpen = false;
      this.isDropdownOpen = false;
      console.log('Hello', this.isOpen);
      this.$emit('input', option.id);
      // this.closeDropdown();
      // Wait for Vue to finish processing `isOpen` change
      this.$nextTick(() => {
        this.closeDropdown();
      });
    },
    handleAddMore(event) {
      event.stopPropagation(); // Prevents the dropdown from toggling
      this.isOpen = false;
      this.isDropdownOpen = false;
      this.$emit('addMore', 'add-more');
    },
    closeDropdown() {
      this.isOpen = false;
      this.isDropdownOpen = false;
    },
    handleOutsideClick(event) {
      if (this.isOpen && !this.$refs.dropdownContainer.contains(event.target)) {
        this.closeDropdown();
      }
    },
    setDropdownNull(data){
      console.log("Data:::",data);
      this.selectedOption=null
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    bus.$on('dropdown-data', this.setDropdownNull);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
};
</script>
   <style scoped>
</style>
